import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  token: string | null
  refreshToken: string | null
  userId: string | null
  userRole: string | null
  setAuth: (token: string, refreshToken: string, userId: string, userRole: string) => void
  setAccessToken: (token: string) => void
  logout: () => void
  isAuthenticated: boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      userId: null,
      userRole: null,
      isAuthenticated: false,
      setAuth: (token, refreshToken, userId, userRole) =>
        set({ token, refreshToken, userId, userRole, isAuthenticated: true }),
      setAccessToken: (token) =>
        set({ token }),
      logout: () =>
        set({ token: null, refreshToken: null, userId: null, userRole: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
    }
  )
)
